module.exports = __webpack_public_path__ + "static/media/exchange.e94fd993.mp3";